import { connect } from 'react-redux'
import Breadcrumbs from './component'
import { path } from 'Utils'

const mapStateToProps = state => {
  return {
    items: [{ to: path('home'), name: 'Home' }, ...state.journey.track.items]
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumbs)
